/**
 * @file routes/_app/audit/orgs/route.tsx
 * @description 組織資訊 Layout 路由（M1）。
 *
 * 稽核專區 → A 組織資訊 的佈局容器。
 * 所有 audit/orgs/* 子路由的 Outlet。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/audit/orgs')({
  component: () => <Outlet />,
});
